import React, {useEffect, useState} from 'react';
import {getTaxpayerVolumenRequest, generateDownloadHistoricalRequest, getCertificatesRequest} from '../Api/Gestion';
import {Checkbox} from 'antd';
import {message} from 'antd';
import {getDateRangeInDays, getDateRangeInMonths, getDateRangeInWeeks} from '../Helpers/DatesCalculus';

export default () => {
    const EMISION = 'Emision';
    const RECEPCION = 'Recepcion';

    const [requestBlock, setRequestBlock] = useState({
        data: [],
        isTableLoading: false,
        selectedRowKeys: [],
        startDate: '',
        endDate: '',
        googleDrive: false,
        requestType: 'WebService',
        allIssuingSelected: true,
        allReceivingSelected: true,

    });

    //equivalent to didMount
    useEffect(() => {
        getIssuers();
    }, [])

    const updateRequestBlockState = (newState) => {
        setRequestBlock((prevState) => ({
            ...prevState,
            ...newState,
        }));
    };

    const getIssuers = async () => {
        updateRequestBlockState({isTableLoading: true});
        const {requestType} = requestBlock;

        try {
            let [taxPayerResponse, certificatesResponse] = await Promise.all([
                await getTaxpayerVolumenRequest(),
                await getCertificatesRequest({page: 1, perPage: 50})
            ])
            
            if (taxPayerResponse.status === 'success' && certificatesResponse.status === 'success') {
                
                let certificatesIndex = {};
                certificatesResponse.data.records.forEach(certificate => certificatesIndex[`${certificate.taxId}`] = certificate);
                
                const objToSend = taxPayerResponse.data
                    .filter(item => certificatesIndex[item.taxId] !== undefined)
                    .map((item, index) => {
                        return {
                            ...item,
                            requestType,
                            issuing: true,
                            receiving: true,
                        }
                    })
                updateRequestBlockState({data: objToSend});
            } else {
                message.error(`${taxPayerResponse.messageDetail || certificatesResponse.messageDetail}`, 5);
            }
        } catch (err) {
            message.error(`${err.messageDetail}`, 5);
        } finally {
            updateRequestBlockState({isTableLoading: false});
        }
    }

    const generateRequests = async () => {
        updateRequestBlockState({isTableLoading: true});
        try {
            const {data, startDate, endDate, googleDrive,} = requestBlock;
            if (startDate === '' || endDate === '') {
                message.error(`Favor de seleccionar un rango de fechas`, 5);
                return;
            }

            const objFormatted = [];
            data.forEach(item => {
                const {receivingVolumeMonthly, issuingVolumeMonthly, issuing, receiving} = item
                const extraPropsIssuing = {googleDrive, requestDocumentType: EMISION};
                const extraPropsReceiving = {googleDrive, requestDocumentType: RECEPCION};
                if (issuing) {
                    if (issuingVolumeMonthly > 60000) {
                        objFormatted.push(getDateRangeInDays(startDate, endDate, extraPropsIssuing, item, 15));
                    } else {
                        objFormatted.push(getDateRangeInMonths(startDate, endDate, extraPropsIssuing, item));
                    }
                }
                if (receiving) {
                    if (receivingVolumeMonthly > 60000) {
                        objFormatted.push(getDateRangeInDays(startDate, endDate, extraPropsReceiving, item, 15));
                    } else {
                        objFormatted.push(getDateRangeInMonths(startDate, endDate, extraPropsReceiving, item));
                    }
                }
            });
            const items = objFormatted.flat();
            const response = await generateDownloadHistoricalRequest(items);
            if (response.status === 'success') {
                message.success(`Se han generado  ${items.length} solicitudes correctamente del periodo que se solicito, estás se podrán visualizar en la lista de solicitudes después de 5 min.`, 5);
            } else {
                message.error(`${response.message}`, 5);
            }
        } catch (err) {
            message.error(`${err.message}`, 5);
        } finally {
            updateRequestBlockState({isTableLoading: false});
        }
    }

    const activateRfc = ({taxId}, type) => {
        const data = requestBlock.data.map(item => {
            if (item.taxId === taxId) {
                item[type] = !item[type];
            }
            return item;
        });
        updateRequestBlockState({data});
    }

    const selectAllIssuer = (type, allSelected) => {
        const data = requestBlock.data.map(item => {
            item[type] = !allSelected;
            return item;
        });
        updateRequestBlockState({data, allIssuingSelected: !allSelected});
    }

    const selectAllReceiver = (type, allSelected) => {
        const data = requestBlock.data.map(item => {
            item[type] = !allSelected;
            return item;
        });
        updateRequestBlockState({data, allReceivingSelected: !allSelected});
    }

    const actions = () => {
        return [
            {
                title: 'RFC de descarga',
                dataIndex: 'taxId',
                key: 'taxId',

            },
            {
                title: () => {
                    const {allIssuingSelected} = requestBlock;
                    return (
                        <>
                            <Checkbox checked={allIssuingSelected} onChange={() => {
                                selectAllIssuer('issuing', allIssuingSelected);
                            }}/>
                            <label style={{marginLeft: '5px'}}>Emitidos</label>
                        </>
                    )
                },
                dataIndex: 'issuing',
                key: 'issuing',
                render: (text, row) => {
                    return <Checkbox onChange={() => {
                        activateRfc(row, 'issuing')
                    }} checked={row.issuing}/>
                },
            },
            {
                title: () => {
                    const {allReceivingSelected} = requestBlock;
                    return (
                        <>
                            <Checkbox checked={allReceivingSelected} onChange={() => {
                                selectAllReceiver('receiving', allReceivingSelected);
                            }}/>
                            <label style={{marginLeft: '5px'}}>Recibidos</label>
                        </>
                    )
                },
                dataIndex: 'receiving',
                key: 'receiving',
                render: (text, row) => {
                    return <Checkbox onChange={() => {
                        activateRfc(row, 'receiving')
                    }} checked={row.receiving}/>
                },
            },
        ];
    }


    return [requestBlock, actions, updateRequestBlockState, generateRequests]
}